// store/reducers/interviewReducer.js
import {
  GET_PIPELINE_REQUEST,
  GET_PIPELINE_SUCCESS,
  GET_PIPELINE_FAILURE,
  CLEAR_PIPELINE_ERROR,
  RESET_PIPELINE,
  GET_COUNTS_SUCCESS,
} from './pipelineAction';

const initialState = {
  pipeline: {
    counts: [],
    data: [],
    loading: false,
    error: null
  }
};

const pipelineReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PIPELINE_REQUEST:
      return {
        ...state,
        pipeline: {
          ...state.pipeline,
          loading: true,
          error: null
        }
      };

    case GET_PIPELINE_SUCCESS:
      return {
        ...state,
        pipeline: {
          ...state.pipeline,
          data: action.payload,
          loading: false,
          error: null
        }
      };

    case GET_PIPELINE_FAILURE:
      return {
        ...state,
        pipeline: {
          ...state.pipeline,
          loading: false,
          error: action.payload
        }
      };

    case CLEAR_PIPELINE_ERROR:
      return {
        ...state,
        pipeline: {
          ...state.pipeline,
          error: null
        }
      };

    case RESET_PIPELINE:
      return {
        ...state,
        pipeline: {
          data: [],
          loading: false,
          error: null
        }
      };

    case GET_COUNTS_SUCCESS:
      return {
        ...state,
        pipeline: {
          ...state.pipeline,
          counts: action.payload
        }
      };
    default:
      return state;
  }
};

export default pipelineReducer;